export class RatingsSummary {

    counts: number[];
    indicators: number[];
    average = 0;
     constructor(){
        this.counts = [];
        this.indicators = [];
     }
 }